import { useEffect, useState } from 'react'
import { useIsAuthenticated } from '@azure/msal-react'

import AuthService from '../../../services/auth.service.ts'

/**
 * Resolves whether the signed in user holds the Coaches app role.
 * The role lives in the access token, so the check is asynchronous.
 *
 * @returns {boolean} true as soon as the Coaches role was confirmed
 */
export default function useIsCoach() {
    const isAuthenticated = useIsAuthenticated();
    const [isCoach, setIsCoach] = useState(false);

    useEffect(() => {
        let cancelled = false;

        if (!isAuthenticated) {
            setIsCoach(false);
            return;
        }

        AuthService.isCoach().then(result => {
            if (!cancelled) {
                setIsCoach(result);
            }
        });

        return () => { cancelled = true; };
    }, [isAuthenticated]);

    return isCoach;
}
